module.exports = __webpack_public_path__ + "img/eupago.15a09a00.png";